// managehttp.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, ActivationEnd } from '@angular/router';
// import { HttpCancelService } from '../services/global/httpcancel.service';
import { takeUntil } from 'rxjs/operators';
import { HttpCancelService } from './httpCancel.service';
import { InstiService } from '../insti.service';

@Injectable()
export class ManageHttpInterceptor implements HttpInterceptor {

    constructor(router: Router,
        private httpCancelService: HttpCancelService,
        protected service: InstiService) {
            router.events.subscribe(event => {
                // An event triggered at the end of the activation part of the Resolve phase of routing.
                if (event instanceof ActivationEnd) {
                  // Cancel pending calls
                  if(event.snapshot['_routerState'].url.indexOf(this.service.getLoginUrl(true)) > -1){//just if the route is to login
                    this.httpCancelService.cancelPendingRequests();
                  }                  
                }
            });
    }

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
      return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()))
    }
}
